/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const MyCredentials = {
  path: '/my-credentials',
  name: 'my-credentials',
  redirect: { name: 'my-credentials-detail' },
  component: () => import('@/views/my-credentials/index.vue'),
  children: [
    {
      path: 'detail',
      name: 'my-credentials-detail',
      component: () =>
        import(/* webpackChunkName: "my-credentials" */ '@/views/my-credentials/detail.vue'),
    },
    {
      path: 'credentials-detail',
      name: 'credentials-detail',
      component: () =>
        import(
          /* webpackChunkName: "my-credentials" */ '@/views/my-credentials/credentials-detail.vue'
        ),
    },
    {
      path: 'credentials-progress-search',
      name: 'credentials-progress-search',
      component: () =>
        import(
          /* webpackChunkName: "my-credentials" */ '@/views/my-credentials/credentials-progress-search.vue'
        ),
    },
  ],
}
export default MyCredentials
